import React from 'react';
import { Phone, Wrench, AlertTriangle, CheckCircle, Search } from 'lucide-react';
export function FuelInjection() {
  return <div className="min-h-screen bg-gray-50" data-id="element-1318">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-1319">
        <div className="container mx-auto px-4" data-id="element-1320">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-1321">
            Automotive Fuel Injection
          </h1>
          <p className="text-xl text-gray-100 text-center italic" data-id="element-1322">
            Serving Farmington Hills, Farmington, Novi, Livonia, Northville
            Since 1958
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-1323">
        <div className="max-w-4xl mx-auto" data-id="element-1324">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1325">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-1326">
              Clean fuel injectors are a must for peak engine performance and
              fuel economy.
            </h2>

            <p className="text-xl text-gray-700 text-center italic mb-8" data-id="element-1327">
              If the injectors are dirty and can't deliver their normal dose of
              fuel, performance, <strong data-id="element-1328">fuel mileage</strong> becomes very
              poor.
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-1329">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/auto%20truck%20suppliers/New%20Folder/epFuelInjectors.png?opt=w3" alt="Fuel injectors" className="w-full h-[280px] object-contain rounded-lg" data-id="element-1330" />
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Fvalve.jpg&site=1986&w=275&h=319&user=1617&opt=w3" alt="Engine valve" className="w-full h-[280px] object-contain rounded-lg" data-id="element-1331" />
            </div>
          </div>

          {/* Dirty Valves Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1332">
            <h2 className="text-4xl font-bold text-gray-900 mb-8 text-center italic" data-id="element-1333">
              Dirty valves can cause
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-6" data-id="element-1334">
              <div className="flex justify-center" data-id="element-1335">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/auto%20truck%20suppliers/New%20Folder/texaco_intake_valve.jpg?opt=w3" alt="Clean valve vs dirty valve comparison" className="max-w-[300px] h-auto rounded-lg" data-id="element-1336" />
              </div>

              <div className="space-y-3" data-id="element-1337">
                <div className="flex items-start" data-id="element-1338">
                  <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1339" />
                  <span className="text-gray-700" data-id="element-1340">Lost fuel economy</span>
                </div>
                <div className="flex items-start" data-id="element-1341">
                  <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1342" />
                  <span className="text-gray-700" data-id="element-1343">
                    Lost power and poor throttle response
                  </span>
                </div>
                <div className="flex items-start" data-id="element-1344">
                  <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1345" />
                  <span className="text-gray-700" data-id="element-1346">Failed emission tests</span>
                </div>
                <div className="flex items-start" data-id="element-1347">
                  <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1348" />
                  <span className="text-gray-700" data-id="element-1349">
                    Poor drivability - surging, hesitation, stalling, rough idle
                  </span>
                </div>
                <div className="flex items-start" data-id="element-1350">
                  <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1351" />
                  <span className="text-gray-700" data-id="element-1352">
                    Engine knocking (pinging) and rap
                  </span>
                </div>
                <div className="flex items-start" data-id="element-1353">
                  <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1354" />
                  <span className="text-gray-700" data-id="element-1355">Difficult starts</span>
                </div>
              </div>
            </div>

            <p className="text-center text-gray-600 font-semibold mt-4" data-id="element-1356">
              Clean Valve vs Dirty Valve
            </p>
          </div>

          {/* BG Fuel Injection Cleaning Results */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1357">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-1358">
              BG Fuel Injection Cleaning Service Results
            </h2>

            <p className="text-gray-700 text-center italic mb-6" data-id="element-1359">
              Two of the four dirty injectors tested were fouled &gt;15% and
              another was fouled &gt;10%. After BG fuel injection cleaning
              service the injectors returned to &gt;95% flow.
            </p>

            <div className="flex justify-center mb-8" data-id="element-1360">
              <img src="http://www.goodoil4u.com/images/api.ht2.jpg" alt="Before and After fuel injection cleaning" className="max-w-full h-auto rounded-lg border shadow-md" data-id="element-1361" />
            </div>

            <div className="bg-green-50 border-l-4 border-green-500 p-6 mb-6" data-id="element-1362">
              <p className="text-gray-800 text-center" data-id="element-1363">
                BG induction service averaged{' '}
                <strong data-id="element-1364">72% intake valve deposit cleanup</strong> across a wide
                range of engine types and sizes, with two cars cleaning up
                greater than 90%.
              </p>
            </div>

            <div className="flex justify-center" data-id="element-1365">
              <img src="http://www.goodoil4u.com/images/api.ht3.jpg" alt="Intake valve deposit cleanup results" className="max-w-full h-auto rounded-lg border shadow-md" data-id="element-1366" />
            </div>
          </div>

          {/* Benefits Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1367">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1368">
              Benefits of Professional Fuel Injection Cleaning
            </h2>

            <div className="space-y-4" data-id="element-1369">
              <div className="flex items-start" data-id="element-1370">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1371" />
                <div data-id="element-1372">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-1373">
                    Restore Fuel Economy
                  </h3>
                  <p className="text-gray-700" data-id="element-1374">
                    Clean injectors deliver the proper fuel mixture for optimal
                    efficiency
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1375">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1376" />
                <div data-id="element-1377">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-1378">
                    Improve Performance
                  </h3>
                  <p className="text-gray-700" data-id="element-1379">
                    Restore lost power and throttle response
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1380">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1381" />
                <div data-id="element-1382">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-1383">
                    Pass Emissions Tests
                  </h3>
                  <p className="text-gray-700" data-id="element-1384">
                    Clean fuel system helps your vehicle meet emission standards
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1385">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1386" />
                <div data-id="element-1387">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-1388">
                    Smoother Operation
                  </h3>
                  <p className="text-gray-700" data-id="element-1389">
                    Eliminate rough idle, hesitation, and stalling
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-1390">
            <h2 className="text-3xl font-bold mb-4" data-id="element-1391">
              Need Fuel Injection Cleaning?
            </h2>
            <p className="text-xl mb-6 italic" data-id="element-1392">If we can help give us a call</p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-1393">
              <Phone className="mr-3" size={24} data-id="element-1394" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-1395">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}